module.exports = __webpack_public_path__ + "payment-icon.png?661fc4d6959b6e8390f7a148e606282b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-icon.png
// module id = 73
// module chunks = 0